import type { ProfileModel } from "../types/models";

// "checkout-block-prepaid" experiment: refusing prepaid cards at checkout
// (81% of their first renewals fail). Control accepts every card; the
// "block-prepaid" arm's Stripe Checkout refuses prepaid cards. klap-api is the
// only place the arm is evaluated (helpers/prepaid_block_experiment.ts there):
// GET /billing/checkout-options says whether this user's Checkout refuses
// prepaid cards, and the plan cards show the notice EU rules require before
// purchase (Interchange Fee Regulation, Art. 10(4)). Delete with the
// experiment.

// Word for word the text klap-api shows above Checkout's pay button
// (PREPAID_BLOCK_CHECKOUT_MESSAGE). Prepaid cards are often printed and sold
// as "debit", hence the explicit wording.
export const PREPAID_BLOCK_NOTICE =
  "Prepaid cards, including prepaid debit and gift cards (also in Apple Pay or Google Pay), aren't accepted. Please use a bank-issued debit or credit card, or another payment method.";

// Signed-in non-guest users without a plan: the only ones whose plan cards
// open Checkout (usePlanCheckout POSTs only when there's no current plan;
// subscribers switch plans with a PATCH). Same rule as klap-api, which also
// leaves everyone else out of the experiment.
export const isPrepaidBlockEligible = (
  profile?: Pick<ProfileModel, "isGuest" | "plan"> | null,
): boolean => !!profile && profile.isGuest === false && !profile.plan;

// Reads GET /billing/checkout-options. Anything unexpected means "not
// blocked".
export const prepaidCardsBlockedFrom = (response: unknown): boolean =>
  !!response &&
  typeof response === "object" &&
  (response as { prepaid_cards_blocked?: unknown }).prepaid_cards_blocked ===
    true;
